// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Homepage from './components/Homepage';
import About from './components/About';
import Contact from './components/Contact';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import ConsumerHealthData from './components/ConsumerHealthData';
import SharingSettings from './components/SharingSettings';
import OurServices from './components/OurServices';
import TellerList from './components/TellerList';
import MobileDownload from './components/MobileDownload';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import Register from './components/Register';
import Logout from './components/Logout';
import UserDashboard from './components/UserDashboard';
import TellerDashboard from './components/TellerDashboard';
import TellerOnboarding from './components/TellerOnboarding';
import VirtualClassroom from './components/VirtualClassroom';
import SessionPayment from './components/SessionPayment';
import SessionEdit from './components/SessionEdit';
import GiftPage from './components/GiftPage';
import PressPage from './components/PressPage';
import PartnershipPage from './components/PartnershipPage';
import SitemapPage from './components/SitemapPage';
import MentalHealthPage from './components/MentalHealthPage';
import RedeemPage from './components/RedeemPage';
import AdminPanel from './components/AdminPanel';
import CookieFloatingButton from './components/CookieFloatingButton';
import CookieConsentBanner from './components/CookieConsentBanner';
import NotificationsPage from './components/NotificationsPage';
import ScrollToTop from './components/ScrollToTop';
import Seo from './components/Seo';
import AccountPrivacyPage from './components/AccountPrivacyPage';
import LegalNotice from './components/LegalNotice';
import {
  AccessibilityStatement,
  AllArticles,
  ContentLibrary,
  CookiePolicy,
  HelpPage,
  HowItWorksPage,
  Leadership,
  SecurityPage,
  SleepAppPage,
  SubscribePage,
} from './components/InfoPages';


const App = () => {
  return (
    <Router>
      <Seo />
      <ScrollToTop />
      <CookieFloatingButton />
      <CookieConsentBanner />
      <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-services" element={<OurServices />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/download" element={<MobileDownload />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/user-dashboard" element={<UserDashboard />} />
          <Route path="/teller-dashboard" element={<TellerDashboard />} />
          <Route path="/onboarding/teller" element={<TellerOnboarding />} />
          <Route path="/teller/:id/available-sessions" element={<TellerList />} />
          <Route path="/teller/:id" element={<TellerList />} />
          <Route path="/session/:id" element={<VirtualClassroom />} />
          <Route path="/session-payment/:id" element={<SessionPayment />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/health-data" element={<ConsumerHealthData />} />
          <Route path="/sharing-settings" element={<SharingSettings />} />
          <Route path="/account-and-google-privacy" element={<AccountPrivacyPage />} />
          <Route path="/legal-notice" element={<LegalNotice />} />
          <Route path="/find-teller" element={<TellerList />} />
          <Route path="/session/edit/:id" element={<SessionEdit />} />
          <Route path="/gift" element={<GiftPage />} />
          <Route path="/redeem" element={<RedeemPage />} />
          <Route path="/articles" element={<AllArticles />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          <Route path="/admin-login" element={<AdminPanel />} />
          <Route path="/content-library" element={<ContentLibrary />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/partnership" element={<PartnershipPage />} />
          <Route path="/sleep-app" element={<SleepAppPage />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/mental-health" element={<MentalHealthPage />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/notifications" element={<NotificationsPage />} />
      </Routes>
    </Router>
  );
};

export default App;
